import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SpinnerInterceptor implements HttpInterceptor {

  count: number = 0;

  constructor(private _spinnerService: NgxSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let spinner = req.headers.get('spinner');
    spinner = (spinner == undefined || spinner == null) ? 'Y' : spinner;
    if (spinner == 'Y') this._spinnerService.show();
    this.count++;
    return next.handle(req).pipe(finalize(() => {
      this.count--;
      if (this.count === 0) {
        if (spinner == 'Y') this._spinnerService.hide();
      }
    }));
  }

}